import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import moment from "moment-timezone";

import ScheduleItem from "./components/ScheduleItem";
import { ITariff } from "@pages/dashboard/components/Price";

interface Expert {
  id: number;
  fullName: string;
  image: string;
  position: string;
  sorting: number;
}

interface WebinarEvent {
  id: number;
  title: string;
  companyTitle: string;
  date: string;
  dateEnd: string;
  description: string;
  experts: Expert[];
  label: string | null;
  participantsCount: number;
  path: string;
  scheduleDescription: string | null;
  standId: number;
  status: number;
  subscribed: boolean;
  type: string;
  viewsCount: number;
}

const PageSuccess: React.FC = () => {
  const location = useLocation();
  const tariffs: ITariff[] = useSelector(
    (state: any) => state.Main?.Workshop?.data.tariffs || []
  );
  const networkingDays = useSelector(
    (state: any) => state.Networking.Days.data
  );
  const currentTariffId = localStorage.getItem("currentTariff")
    ? Number(localStorage.getItem("currentTariff"))
    : Number(new URLSearchParams(location.search).get("tariffId"));

  const workshopTitle: string = useSelector(
    (state: any) => state.Main.Workshop.data.title
  );
  const scheduleList: WebinarEvent[] = useSelector(
    (state: any) => state.Schedule?.list || []
  );
  const endWorkshop = useSelector(
    (state: any) => state.Main.Workshop.data?.endAt
  );
  const scheduleId = Number(process.env.SCHEDULE_ID);

  useEffect(() => {
    Middleware.Schedule.section(scheduleId, networkingDays);
  }, [networkingDays, scheduleId]);

  useEffect(() => {
    Middleware.Schedule.sectionList();
    Middleware.Profile.load();
  }, []);

  const now = moment().tz("Europe/Moscow");
  const futureEvents = scheduleList
    .map((ev) => ({
      ...ev,
      eventDate: moment(ev.date).tz("Europe/Moscow"),
    }))
    .filter((ev) => ev.eventDate.isAfter(now));

  const nearestDay =
    futureEvents.length > 0
      ? futureEvents
          .reduce(
            (min, event) =>
              event.eventDate.isBefore(min) ? event.eventDate : min,
            futureEvents[0].eventDate
          )
          .startOf("day")
      : null;

  const nearestEvents = nearestDay
    ? futureEvents.filter((ev) => ev.eventDate.isSame(nearestDay, "day"))
    : [];

  return (
    <div className="payment">
      <div className="cont payment__cont">
        <div className="payment__wrapper">
          <div className="payment__header">
            <h1 className="payment__title">
              Поздравляем!
              <span>Доступ к OTM: WINTER 25/26 открыт.</span>
            </h1>
            <div className="payment__desc">
              <p>
                С 25 августа по 17 сентября на нашей площадке пройдут вебинары
                по зимним зарубежным направлениям от туроператоров, DMC, отелей
                и авиакомпаний, а также практикум для турагентов о работе с ИИ,
                персональными данными, фото, видео и форс-мажорами.
              </p>
              <p>
                Вы можете посещать <b>все мероприятия</b> или составить
                индивидуальное расписание.
              </p>
              <Link
                to="/?anchor=schedule-anchor"
                className="payment__header-link btn btn--red-underline"
                onClick={() => localStorage.removeItem("currentTariff")}
              >
                Составить персональное расписание
              </Link>
            </div>
          </div>

          {!!nearestEvents.length && (
            <div className="payment__schedule">
              <div className="payment__schedule-header">
                <h2 className="payment__schedule-title">Интересные события</h2>
                <div className="payment__schedule-desc">
                  <Link
                    to="/?anchor=schedule-anchor"
                    className="payment__header-link btn btn--red-underline"
                    onClick={() => localStorage.removeItem("currentTariff")}
                  >
                    Посмотреть расписание
                  </Link>
                </div>
              </div>

              <div className="payment__schedule-list">
                {nearestEvents.map((event) => (
                  <ScheduleItem
                    key={event.id}
                    specialClass="payment__schedule-item"
                    specialDayDate={event.eventDate.format("D MMMM")}
                    specialDayName={event.title}
                    webinar={event}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageSuccess;
